<template>
  <div class="scene-embedded-list">
    <div class="container">
      <div class="list-wrap">
        <div class="list-item" v-for="listItem in embeddedSceneList"
             :class="{ 'active': activeItem && activeItem.id === listItem.id }"
             @click="onSceneSelect(listItem)">
          <div class="list-item-image" :style="{ 'background-image': `url(${listItem.thumbnail})` }"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SceneEmbeddedList',

    props: ['show', 'currentSceneId'],

    data() {
      return {
        embeddedSceneList: [],
        activeItem: null
      }
    },

    mounted() {
      this.embeddedSceneList = window.Config.scenes.embedded

      if (this.embeddedSceneList.length) {
        this.embeddedSceneList.map(item => {
          if (item.id === this.currentSceneId) {
            this.activeItem = item
          }
        })
      }
    },

    methods: {
      onSceneSelect(listItem) {
        if (this.activeItem.id !== listItem.id) {
          this.activeItem = listItem
          this.$emit('embeddedSceneSelect', listItem.id)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/styles/mixins";
  @import "../../../assets/styles/main";

  .scene-embedded-list {
    background-color: #ccc;
    @include border-radius(4px);

    .list-wrap {
      display: flex;
      overflow-x: auto;
      padding: 10px;

      .list-item {
        @include border-radius(4px);
        cursor: pointer;
        margin: 0 5px;

        &:first-child {
          margin-left: 0;
        }

        &:last-child {
          padding-right: 10px;
          margin-right: 0;
        }

        .list-item-image {
          background: #444 no-repeat center center;
          background-size: cover;
          border: 4px solid transparent;
          @include border-radius(4px);
          width: 250px;
          height: 150px;
        }

        &.active {
          .list-item-image {
            border-color: $color-primary;
          }
        }
      }
    }
  }
</style>
